import React from 'react';
import { cn } from '@lib/utils';

export interface QuestionCardSkeletonProps {
  /**
   * The blocks' fill. `default` is the feed's grey; `progress-track` is the Post sheet's (frames
   * E18, E18b: every block `mb-progress-track`), passed by the sheet so no other skeleton changes.
   */
  tone?: 'default' | 'progress-track';
}

export const QuestionCardSkeleton: React.FC<QuestionCardSkeletonProps> = ({ tone = 'default' }) => {
  const block = (className: string) => (
    <div
      data-testid="question-card-skeleton-block"
      className={cn(className, tone === 'progress-track' ? 'bg-mb-progress-track' : 'bg-gray-200')}
    />
  );
  return (
    <div
      data-testid="question-card-skeleton"
      className="w-full bg-neutral-50 rounded-[20px] border-none shadow-xs p-5 animate-pulse"
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2.5">
          {block('w-[52px] h-[52px] rounded-full')}
          <div className="flex flex-col gap-2">
            {block('h-4 w-32 rounded-sm')}
            {block('h-3 w-24 rounded-sm')}
          </div>
        </div>
        {block('w-6 h-6 rounded-sm')}
      </div>

      {/* Title and content */}
      <div className="space-y-3 mb-4">
        {block('h-4 w-3/4 rounded-sm')}
        {block('h-3 w-full rounded-sm')}
        {block('h-3 w-5/6 rounded-sm')}
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between gap-2">
        {block('h-[38px] w-16 rounded-[25px]')}
        {block('h-[38px] w-28 rounded-[25px]')}
        {block('h-[38px] w-28 rounded-[25px]')}
      </div>
    </div>
  );
};
